import React from "react";
import {
  BorderedContainerSizeEnum,
  StyledBorderedContainer,
  StyledBorderedLabel,
} from "./BorderedContainer.styled";
import { IconManager } from "../core/IconManager/IconManager";
import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { BodyTyp } from "../Typography/Typography";

export { BorderedContainerSizeEnum };

type BorderedContainerProps = {
  label?: string;
  icon?: React.JSX.Element;
  children?: React.ReactNode;
  size?: BorderedContainerSizeEnum;
};

export const BorderedContainer = ({
  icon,
  label,
  children,
  size = BorderedContainerSizeEnum.LARGE,
}: BorderedContainerProps) => {
  return (
    <StyledBorderedContainer $size={size}>
      {label && (
        <StyledBorderedLabel $size={size}>
          {icon && (
            <IconManager
              color={theme.colors.black}
              size={IconSizeEnum.SMALL}
              marginRight={size === BorderedContainerSizeEnum.SMALL ? 5 : 8}
            >
              <BodyTyp fontWeight={FontWeightEnum.MEDIUM}>{icon}</BodyTyp>
            </IconManager>
          )}
          <BodyTyp fontWeight={FontWeightEnum.MEDIUM}>{label}</BodyTyp>
        </StyledBorderedLabel>
      )}
      {children}
    </StyledBorderedContainer>
  );
};
